import type { IconData } from '@stacksjs/iconify-core'

export const emptyClipboardSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M31.638 4.347c.196-1.73-1.12-3.265-2.861-3.3A232 232 0 0 0 24.001 1c-1.765 0-3.353.017-4.778.046c-1.742.036-3.057 1.57-2.861 3.301l.224 1.99A3 3 0 0 0 19.567 9h8.866a3 3 0 0 0 2.98-2.663zm2.981.337q.054-.479.033-.946c1.51.078 2.762.167 3.785.256c3.023.262 5.314 2.543 5.57 5.575c.246 2.922.493 7.763.493 15.431s-.247 12.509-.493 15.431c-.256 3.032-2.547 5.313-5.57 5.576c-2.838.246-7.43.493-14.437.493s-11.6-.247-14.437-.493c-3.023-.263-5.314-2.544-5.57-5.576C3.747 37.51 3.5 32.667 3.5 25s.247-12.509.493-15.431c.256-3.032 2.547-5.313 5.57-5.575a106 106 0 0 1 3.785-.256q-.02.467.033.946l.224 1.99A6 6 0 0 0 19.567 12h8.866a6 6 0 0 0 5.962-5.327z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default emptyClipboardSolid
